import { render, staticRenderFns } from "./ContactsListModal.vue?vue&type=template&id=8ade0efe&scoped=true&lang=pug"
import script from "./ContactsListModal.vue?vue&type=script&lang=js"
export * from "./ContactsListModal.vue?vue&type=script&lang=js"
import style0 from "./ContactsListModal.vue?vue&type=style&index=0&id=8ade0efe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ade0efe",
  null
  
)

export default component.exports